"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomCoder = void 0;
var TDNode_1 = require("../TDNode");
var TDJSONParser_1 = require("../json/TDJSONParser");
var TDJSONParserOption_1 = require("../json/TDJSONParserOption");
var CustomCoder = /** @class */ (function () {
    function CustomCoder() {
    }
    CustomCoder.get = function () {
        return CustomCoder.it;
    };
    CustomCoder.prototype.encode = function (obj, opt, target, ctx) {
        if (!obj.toJSON)
            return false;
        var jsonStr = obj.toJSON();
        if (typeof (jsonStr) !== 'string')
            return false;
        var node = TDJSONParser_1.TDJSONParser.get().parse(jsonStr, TDJSONParserOption_1.TDJSONParserOption.ofDefaultRootType(TDNode_1.TDNodeType.SIMPLE));
        target.setType(node.type).setValue(node.value).children = node.children;
        return true;
    };
    CustomCoder.it = new CustomCoder();
    return CustomCoder;
}());
exports.CustomCoder = CustomCoder;
//# sourceMappingURL=CustomCoder.js.map